import { VehicleReservationSearchResult } from './VehicleReservationSearchResult';
export class Branch {
  id: string;
  agencyID: string;
  name: string;
  price: number;
  totalCars: number;
  position: any;
  icon: string;
  iconUrl1: string;
  iconUrl2: string;
  isHovered: boolean;
  hasCampaign: boolean;
  baseRate: number;
  calculatedBaseRate: number;
  totalRentals: number;
  distance: number;
  periodInDays: number;
  durationUnitName: string;
  locationName: string;
  constructor(model: VehicleReservationSearchResult, iconUrl1, iconUrl2, index) {
    //this.id=index;
    this.id = model.agencyID;
    this.agencyID = model.agencyID;
    this.baseRate = model.baseRate;
    this.calculatedBaseRate = model.calculatedBaseRate;
    this.distance = model.distance;
    this.name = model.companyName;
    this.hasCampaign = model.hasCampaign;
    this.position = { lat: model.latitude, lng: model.longitude };
    this.totalCars = model.availableVehicles;
    this.price = model.rentalUnitPrice;//For Now
    this.totalRentals = model.totalRentals
    this.iconUrl1 = iconUrl1;
    this.iconUrl2 = iconUrl2;
    this.icon = iconUrl1;
    this.isHovered = false;
    this.name = model.companyName;
    this.periodInDays = model.durationInDays;
    this.durationUnitName = model.durationUnitName != null ? model.durationUnitName.replace('-', ' ') : '';
    this.locationName = model.locationName;
  }
}
